'use client';

import React from 'react';
import { FullListing } from '@th/shared/src/types/FullListing';
import BlurText from '../BlurText';
import isDefinedAndNonNull from '@th/shared/src/utils/isDefinedAndNonNull';
import { useUser } from '../../contexts/UserContext';

type Props = {
  listing: FullListing;
  isBlurred: boolean;
};

export default function ListingStatusSection({ listing, isBlurred }: Props) {
  const color = listing.lastStatusColor();
  const { isLoggedIn } = useUser();
  const daysOnMarketText = isLoggedIn ? 'days on market' : 'days on TopHouse';

  const DaysOnMarketText = () => {
    const daysOnMarket = listing.daysOnMarket();
    return (
      <span>
        <BlurText isBlurred={isBlurred}>
          {isDefinedAndNonNull(daysOnMarket) ? daysOnMarket.toString() : '-'}
        </BlurText>{' '}
        {daysOnMarketText}
      </span>
    );
  };

  const hasNeighborhood = Boolean(listing.address.neighborhood);
  return (
    <div>
      {listing.isMissingSoldDateOrPrice() ? (
        <div className="flex items-baseline">
          <p>
            <span className={`font-bold`} style={{ color }}>
              {listing.lastStatusText()}
            </span>{' '}
            {hasNeighborhood && (
              <span className="text-secondaryText">
                in {listing.address.neighborhood}{' '}
              </span>
            )}
            {isDefinedAndNonNull(listing.daysOnMarket()) && (
              <span className="text-secondaryText">
                | <DaysOnMarketText />
              </span>
            )}
          </p>
        </div>
      ) : (
        <div>
          <div className="flex items-baseline">
            <p>
              <span className={`font-bold`} style={{ color }}>
                {listing.lastStatusText()}
              </span>
              {hasNeighborhood && (
                <span className="ml-2 text-secondaryText">
                  in {listing.address.neighborhood}
                </span>
              )}
            </p>
          </div>
          <p className="text-secondaryText">
            Sold on{' '}
            <BlurText isBlurred={isBlurred}>
              {listing.soldDateText() || ''}
            </BlurText>{' '}
            | <DaysOnMarketText />
          </p>
        </div>
      )}
    </div>
  );
}
